import {gql} from '@apollo/client'

export const ProfileFragment = gql`
    fragment ProfileComponentProfile on ProfileObject {
        idStr
        fullName
        secondaryLine
        photo {
            idStr
            thumbUrl
        }
    }
`
